import { SECTION,WIDGET } from "../models/app-json";
import { WIDGET_TYPES } from "./proj.cnst";

const  widgetTypes = WIDGET_TYPES;

const simpleForm: WIDGET[] = [
  { widgetId: 'textbox1', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120003',  key:'MWTI',name: 'Text1', widgetType: widgetTypes.textbox, type: 'text', element: { label:'Field',placeholderText: 'Enter text...', isRequired: false, showLabel: true }, showDeleteButton: true,customStyleApplied: false, validations: [], style:{}},
  { widgetId: 'textbox2', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120003', key:'MW', name: 'Text2',widgetType: widgetTypes.textbox, type: 'text', element: { label:'Field',placeholderText: 'Enter text...', isRequired: false, showLabel: true }, showDeleteButton: true,customStyleApplied: false, validations: [], style:{}},
  { widgetId: 'textbox3', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120003', key:'', name: 'Text3',widgetType: widgetTypes.textbox, type: 'text', element: { label:'Field',placeholderText: 'Enter text...', isRequired: false, showLabel: true },  showDeleteButton: true,customStyleApplied: false, validations: [], style:{}},
  { widgetId: 'saveButton1', masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120011', key:'', name: 'form button', widgetType: widgetTypes.button,type:'submit',showDeleteButton: true,customStyleApplied: false,validations: [], values: 'Save', style: { width:'100%',
  },}
]

const MostPopular: WIDGET[] = [
  { widgetId: 'button', key:'',name:"Icon Button",widgetType:"button",image:"dialpad",  showDeleteButton: true,customStyleApplied: false,style:{}},
  { widgetId: 'button', key:'',name:"Check Box",widgetType:"button",image:"check_box",  showDeleteButton: true,customStyleApplied: false, style:{}},
  { widgetId: 'button', key:'',name:"Image",widgetType:"button", image:"image",  showDeleteButton: true,customStyleApplied: false,style:{} }
]

const Navigation: SECTION[] = [
  {
    sectionId: 'section2',
    index:0,
    key:'',
    name:"NavBar",
    sectionType:"Navgation Bar",
    image:'navigation',
    showDeleteButton:false,
    style: {
    },
    widgets: [{ widgetId: 'button',
    masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120011',
    key: '',
    name: 'Nav Icon 1',
    image: 'arrow_back',
    widgetType: widgetTypes.navButton,
    showDeleteButton: false,
    customStyleApplied: false,
    type: 2,
    style: {
    },
    values: 'Next',
    enabled: true
  },
  { widgetId: 'heading1',masterWidgetId:'ae913c6e-837e-11ee-b962-0242ac120002', key:'',name:"Title",widgetType:widgetTypes.navText,values: 'Title', showDeleteButton: true,customStyleApplied: false,image:"title" ,style:{
  }, enabled: true},
  { widgetId: 'button',
    masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120011',
    key: '',
    name: 'Nav Icon 2',
    image: 'sync',
    widgetType: widgetTypes.navButton,
    showDeleteButton: false,
    customStyleApplied: false,
    type: 1,
    style: {
    },
    values: 'Next',
    enabled: false
  }
],
    isEditable:true,
  },
]

const FormsAndFields: WIDGET[] = [
  { widgetId: 'scanner',index:1, masterWidgetId: '2801838f-e73c-4c5b-b0ac-cc2d1df93820',  key:'',name: 'Scanner', widgetType: widgetTypes.scanner,image: 'Scanner', showDeleteButton: true, customStyleApplied: false, style:{}},
  { widgetId: 'imageWidget1', index:1,masterWidgetId: 'f9098456-8d2c-11ee-b9d1-0242ac120002',  key:'',name: 'image', widgetType: widgetTypes.imageUploader,image: 'image', showDeleteButton: true, customStyleApplied: false, style:{}},
  { widgetId: 'heading1',index:1, masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120002", key:'',name:"Text",widgetType:widgetTypes.plainText,values: 'Text', showDeleteButton: true,customStyleApplied: false,image:"rich_text" ,style:{}},
  { widgetId: 'inputCheckbox1', index:1,masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120010", key:'',name:"Check Box",widgetType:widgetTypes.singleselectcheckbox,image:"check_box", type: 'checkbox',customStyleApplied: false,  showDeleteButton: true ,style:{}},
  { widgetId: 'inputRadio1', index:1,masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120009", key:'',name:"Radio Button",widgetType:widgetTypes.radio,image:"radio_button", type: 'radio',  showDeleteButton: true ,customStyleApplied: false, values: ['value1', 'value2',],style:{}},
  { widgetId: 'inputText1', index:1,masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120003", key:'', name:"Text Field", widgetType:widgetTypes.textbox, image:"text_placeholder", type: 'text', element: { label:'Text Field',placeholderText: 'Enter text...', isRequired: false, showLabel: true},  showDeleteButton: true ,customStyleApplied: false, validations: [], style: {}},
  { widgetId: 'inputFile1', index:1,masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120004", key:'', name:"File Picker", widgetType:widgetTypes.filePicker,image:"file_picker", type: 'file',  showDeleteButton: true,customStyleApplied: false ,style:{}},
  { widgetId: 'select1',index:1, masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120006",  key:'',name:"Drop Down", widgetType:widgetTypes.dropdown, image:"select_dropdown", element: {placeholderText: '', isRequired: false, showLabel: true}, showDeleteButton: true ,customStyleApplied: false, values: [],style:{},type:'SingleSelect'},
  { widgetId: 'inputImage1', index:1,masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120005", key:'', name:"Media Upload", widgetType:widgetTypes.image, image:"image_picker", type: 'file',  showDeleteButton: true ,customStyleApplied: false,style:{}}, 
  { widgetId: 'inputDate1', index:1,masterWidgetId : "ae913c6e-837e-11ee-b962-0242ac120008", key:'', name:"Date Picker", widgetType:widgetTypes.date, image:"date_picker", type: 'date', values: '2023-10-31' , showDeleteButton: true,customStyleApplied: false,style:{} }, 
]
 
const SECTION_META : SECTION[] = [{
    key:'',
    sectionId: 'section1',
    name:"form",
    image:'form',
    sectionType:"form",
    showDeleteButton:false,
    style: {

    },
    widgets: simpleForm,
    isEditable:false,
  },
  {
    sectionId: 'section2',
    key:'',
    name:"subform",
    sectionType:"subform",
    image:'custom_list',
    showDeleteButton:false,
    style: {

    },
    widgets: simpleForm,
    isEditable:false,
  },
  {
    key:'',
    sectionId: 'section1',
    name:"menu panel",
    image:'form',
    sectionType:"menuPanel",
    showDeleteButton:false,
    style: {
  
    },
    widgets: [],
    isEditable:false,
  }

];

const Buttons: WIDGET[] = [{
  widgetId: 'button',
  index:2,
  masterWidgetId: 'ae913c6e-837e-11ee-b962-0242ac120011',
  key: '',
  name: 'Save',
  image: 'button',
  widgetType: widgetTypes.button,
  showDeleteButton: false,
  customStyleApplied: false,
  type: 'submit',
  style: {
    width:'100%',

  },
  values: 'Next'
},
]

const addOns: WIDGET[] = [
  {
    widgetId: "separator",
    index: 3,
    masterWidgetId: "f9098456-8d2c-11ee-b9d1-0242ac120002",
    key: "",
    name: "Separator",
    widgetType: widgetTypes.separator,
    image: "separation",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {
      size: "5px",
    },
  },
  {
    widgetId: "geotag",
    index: 3,
    masterWidgetId: "f9098456-8d2c-11ee-b9d1-0242ac120002",
    key: "",
    name: "Geotag",
    widgetType: widgetTypes.geotag,
    image: "geotag",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {},
  },
  {
    widgetId: "geofence",
    index: 3,
    masterWidgetId: "b517cc34-c609-4219-bca3-446a4d137dd5",
    key: "",
    name: "Geofence",
    widgetType: widgetTypes.geofence,
    image: "geofence",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {},
  },
  {
    widgetId: "address",
    index: 3,
    masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120003",
    key: "",
    name: "Address",
    widgetType: widgetTypes.address,
    image: "address",
    showDeleteButton: true,
    customStyleApplied: false,
    element: {
      placeholderText: "Enter text...",
      isRequired: false,
      showLabel: true,
    },
    style: {},
  },
  {
    widgetId: "printer",
    index: 3,
    masterWidgetId: "f9098456-8d2c-11ee-b9d1-0242ac120002",
    key: "",
    name: "Printer",
    widgetType: widgetTypes.printer,
    image: "thermal-printer",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {
      width:'100%',
    },
  },
  {
    widgetId: "chatbot",
    index: 3,
    masterWidgetId: "4cbe2177-88ae-4cbe-b143-eb72236c7a08",
    key: "",
    name: "Chatbot",
    widgetType: widgetTypes.chatBot,
    image: "address",
    showDeleteButton: true,
    customStyleApplied: false,
    element: {
      isRequired: false,
      showLabel: true,
    },
    style: {
      width:'100%',
    },
  },
  {
    widgetId: "chatBox",
    index: 3,
    masterWidgetId: "c8b3222f-4d6f-4d88-b47e-cde788b9f747",
    key: "",
    name: "Chat View",
    widgetType: widgetTypes.chatView,
    image: "thermal-printer",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {
      width:'100%',
    },
    additionalConfig:{
     isLogo : 1
    }
  },
  {
    widgetId: "filter",
    index: 3,
    masterWidgetId: "6f82cd65-9ec0-47a5-8c87-d678d52162ef",
    key: "",
    name: "filter",
    widgetType: widgetTypes.filter,
    image: "filter",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {
      width:'100%',
    },
    additionalConfig:{
     isLogo : 1
    }
  }
];

const displayWidgets : WIDGET[] = [
  {
    widgetId: "datalist",
    index: 4,
    masterWidgetId: "2801838f-e73c-4c5b-b0ac-cc2d13df9382",
    key: "",
    name: "Data List",
    widgetType: widgetTypes.datalist,
    image: "data_list",
    values: "",
    showDeleteButton: true,
    customStyleApplied: false,
    style: {},
  },
  {
    widgetId: "barchart",
    index: 4,
    masterWidgetId: "ae913c6e-837e-11ee-b962-0242ac120012",
    key: "",
    name: "Bar Chart",
    widgetType: WIDGET_TYPES.barChart,
    image: "bar_chart",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "lineChart",
    index: 4,
    masterWidgetId: "ae913c6e-837e-11ee-f962-0452ac123412",
    key: "",
    name: "Line Chart",
    widgetType: WIDGET_TYPES.lineChart,
    image: "line_chart",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "pieChart",
    index: 4,
    masterWidgetId: "ae913c6e-837e-11ee-b962-0452ac123412",
    key: "",
    name: "Pie Chart",
    widgetType: WIDGET_TYPES.pieChart,
    image: "pie_chart",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "donutChart",
    index: 4,
    masterWidgetId: "ae913c6e-837e-11ee-b962-0452ac123412",
    key: "",
    name: "donut Chart",
    widgetType: WIDGET_TYPES.donutChart,
    image: "donut",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "stackBarChart",
    index: 4,
    masterWidgetId: "ae913c6e-837e-11ee-b962-0452ac123412",
    key: "",
    name: "Stackbar Chart",
    widgetType: WIDGET_TYPES.stackBarChart,
    image: "stack_bar_chart",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "fixedBarChart",
    index: 4,
    masterWidgetId: "ae913c6e-837e-51ee-b962-0452ac123412",
    key: "",
    name: "FixedBar Chart",
    widgetType: WIDGET_TYPES.fixedBarChart,
    image: "fixedBar",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "aggregator",
    index: 4,
    masterWidgetId: "71eac59a-3d14-49f9-9a77-07f80bb26034",
    key: "",
    name: "Data board",
    widgetType: WIDGET_TYPES.dataBoard,
    image: "data_board",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  },
  {
    widgetId: "overviewTracker",
    index: 4,
    masterWidgetId: "e5694c1d-e76e-44a0-829c-915bd101f458",
    key: "",
    name: "O.Tracker",
    widgetType: WIDGET_TYPES.overviewTracker,
    image: "overview_tracker",
    values: "",
    customStyleApplied: false,
    showDeleteButton: true,
    style: { width: "100%" },
  }
];

export const CATEGORIES_META_DATA : { type: string, items: (WIDGET|SECTION)[]}[]= [
  // { type:"Most Popular", widgets:MostPopular },
  { type:"Navigation", items:Navigation },
  { type:'Form Fields', items: FormsAndFields },
  { type:'Buttons', items:Buttons } ,
  { type:'Add Ons', items:addOns},
  { type: 'Display', items: displayWidgets}
]

